import React from 'react'

import Chat from 'components/Artefacts/Chat'
import useRoomState from 'hooks/useRoomState/useRoomState'

import { EndCallButton } from './components/EndCallButton'
import { Reactions } from './components/Reactions'
import { SpeakingOnMute } from './components/SpeakingOnMute'
import { ToggleAudioButton } from './components/ToggleAudioButton'
import { ToggleVideoButton } from './components/ToggleVideoButton'
import {
    LeftControls,
    RightControls,
    AudioVideoContainer,
    CenterControls,
    ChatButtonContainer,
    Container,
    AudioVideoSeparator,
} from './styles'

const BottomControlBar = () => {
    const roomState = useRoomState()
    const isReconnecting = roomState === 'reconnecting'

    return (
        <Container>
            <LeftControls>
                <EndCallButton />
                <AudioVideoContainer>
                    <ToggleVideoButton disabled={isReconnecting} />
                    <AudioVideoSeparator />
                    <ToggleAudioButton disabled={isReconnecting} />
                    <SpeakingOnMute />
                </AudioVideoContainer>
            </LeftControls>
            <CenterControls>
                <Reactions />
            </CenterControls>
            <RightControls>
                <ChatButtonContainer>
                    <Chat />
                </ChatButtonContainer>
                <div id="pagination-portal-root" />
            </RightControls>
        </Container>
    )
}

export { BottomControlBar }
